import { SentenceType } from 'types/types'
import { Ref, watch } from 'vue'
import { VueLogger } from 'vue-logger-plugin'

import store from '@/store'

const useSentences = (sentences: Ref<Array<SentenceType>>, logger: VueLogger) => {
  return {
    watchSentences() {
      // curiously, () => sentences syntax does _now_ work here
      watch(sentences, () => {
        console.log('useSentences watcher fired, sentences.value.length =', sentences.value.length)
        console.log('useSentences sentences.value =', sentences.value)
        logger.debug('watch sentences from useSentences, downloading sentences.value =')
        logger.debug(sentences.value)
        if (!sentences.value.length) {
          console.log('useSentences: sentences is empty, skipping fetchRecordings')
          return
        }
        console.log('useSentences: calling store.dispatch.audio.fetchRecordings')
        store.dispatch.audio.fetchRecordings({ sentences: sentences.value })
      })
    },
  }
}

export { useSentences }
